import React, { forwardRef, useImperativeHandle, useState } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";
import * as BiIcon from "react-icons/bi";


const Modal_ProductCardex = forwardRef((props, ref) => {

    const [ItemList, setItemList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [ProductId, setProductId] = useState(General.GuidEmpty());
    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [Open, setOpen] = useState(false);
    const [BeginDate, setBeginDate] = useState(null);
    const [EndDate, setEndDate] = useState(null);
    const [Product, setProduct] = useState("");
    const [StoreRoom, setStoreRoom] = useState("");
    // const toaster = rsuite.useToaster();
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)
    const CompactCell = props => <rsuite.Table.Cell {...props} style={{ padding: 4 }} />;
    const CompactHeaderCell = props => <rsuite.Table.HeaderCell {...props} style={{ padding: 4 }} />;
    const defaultColumns = [
        {
            key: 'row',
            label: '#',
            fixed: true,
            sortable: true,
            width: 50,
            defaultOn: true

        },
        {
            key: 'Code',
            label: 'رسید / حواله',
            fullText: true,
            sortable: true,
            fixed: true,
            width: 100,
            defaultOn: true

        },

        {
            key: 'Product',
            label: 'محصول',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1,
            defaultOn: true

        },
        // {
        //     key: 'ProductIdentityNo',
        //     label: 'شناسه محصول',
        //     fixed: true,
        //     fullText: true,
        //     resizable: true,
        //     sortable: true,
        //     flexGrow: 1,
        //     defaultOn: true

        // },
        {
            key: 'InsertDateTime',
            label: ' تاریخ ثبت',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'ConfirmDateTime',
            label: ' تاریخ تایید',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },

        {
            key: 'InputCount',
            label: 'تعداد ورود',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'OutputCount',
            label: 'تعداد خروج',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        }
        ,
        // {
        //     key: 'BeforPhysicalCount',
        //     label: 'تعداد فیزیکی قبل',
        //     fullText: true,
        //     resizable: true,
        //     sortable: true,
        //     width: 100,
        //     defaultOn: true

        // },
        // {
        //     key: 'BeforSaleCount',
        //     label: 'تعداد قابل فروش قبل',
        //     fullText: true,
        //     resizable: true,
        //     sortable: true,
        //     width: 100,
        //     defaultOn: true

        // },
        {
            key: 'NextPhysicalCount',
            label: 'تعداد فیزیکی',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'NextSaleCount',
            label: 'تعداد قابل فروش',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },

        {
            key: 'Price',
            label: 'قیمت واحد',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true
        },
        // {
        //     key: 'DiscountPrice',
        //     label: 'تخفیف واحد',
        //     fullText: true,
        //     resizable: true,
        //     sortable: true,
        //     width: 100,
        //     defaultOn: false
        // },
        // {
        //     key: 'Tax',
        //     label: 'مالیات واحد',
        //     fullText: true,
        //     resizable: true,
        //     sortable: true,
        //     width: 100,
        //     defaultOn: false
        // }
        // ,
        {
            key: 'TotalPrice',
            label: 'قیمت کل',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: false
        }
        ,
        {
            key: 'IsConfirm',
            label: 'وضعیت',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: false
        }
    ];

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    // const handleChangeLimit = dataKey => {
    //     setPage(1);
    //     setLimit(dataKey);
    // };


    const [compact, setCompact] = React.useState(true);
    const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
    // const CustomCell = compact ? CompactCell : rsuite.Table.Cell;
    const CustomHeaderCell = compact ? CompactHeaderCell : rsuite.Table.HeaderCell;
    // const [limit, setLimit] = React.useState(10);
    // const [page, setPage] = React.useState(1);

    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }



    useImperativeHandle(ref, () => ({
        Bind(id, storeRoomId, product, storeRoom) {
            setProductId(id);
            setStoreRoomId(storeRoomId);
            setOpen(true);
            setProduct(product);
            setStoreRoom(storeRoom)
            Search(id, storeRoomId)


        },
    }),
        [props.value])




    const Search = (productId, storeRoomId) => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomReport/Count_CardexReport', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                    'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                    'ProductId': productId,
                    'GroupId': -1,
                    'GroupParentId': -1,
                    'FiscalYearId': FiscalYearId,
                    'StoreRoomId': storeRoomId,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []

                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Price: PN.sliceNumber(result[i].price),
                            Tax: PN.sliceNumber(result[i].tax),
                            TotalPrice: PN.sliceNumber(result[i].totalPrice),
                            DiscountPrice: PN.sliceNumber(result[i].discountPrice),
                            BeforPhysicalCount: result[i].beforPhysicalCount,
                            BeforSaleCount: result[i].beforSaleCount,
                            NextPhysicalCount: result[i].nextPhysicalCount,
                            NextSaleCount: result[i].nextSaleCount,
                            InputCount: result[i].draftType == "Recipt" ? result[i].count : 0,
                            OutputCount: result[i].draftType != "Recipt" ? result[i].count : 0,
                            Product: result[i].product,
                            DraftType: result[i].draftType,
                            ProductIdentityNo: result[i].productIdentityNo,
                            StoreRoom: result[i].storeRoom,
                            InsertDateTime: result[i].insertDate + " " + result[i].insertTime,
                            ConfirmDateTime: result[i].confirmDate + " " + result[i].confirmTime,
                            Code: result[i].headerCode,
                            InsertUser: result[i].insertUser,
                            IsConfirm: result[i].confirmId != General.GuidEmpty() ? "تایید شده" : "تایید نشده",

                        })
                    }
                    setItemList(tmp)
                })
        )
    }




    return (
        <rsuite.Modal open={Open} size="full" onClose={() => setOpen(false)} style={{ "zIndex": 10000 }} >
            <rsuite.Modal.Header>
                <rsuite.Modal.Title><b>کاردکس  : {Product}  -  {StoreRoom}</b></rsuite.Modal.Title>
            </rsuite.Modal.Header>
            <rsuite.Modal.Body>
                <rsuite.Panel className="bg-white mt-2">
                    <rsuite.Row  >
                        <rsuite.Col xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> فیلتر   </label>
                            <rsuite.VStack spacing={16}>
                                <rsuite.TagPicker
                                    data={defaultColumns}
                                    labelKey="label"
                                    valueKey="key"
                                    value={columnKeys}
                                    onChange={setColumnKeys}
                                    cleanable={false}
                                    className='Font10 w-100p'
                                />
                            </rsuite.VStack>
                        </rsuite.Col>
                    </rsuite.Row>
                    <hr />

                    <rsuite.Table
                        height={400}
                        // data={List}
                        loading={loading}
                        data={ItemList.sort((a, b) => {
                            let x = a[sortColumn];
                            let y = b[sortColumn];
                            if (typeof x === 'string') {
                                x = x.charCodeAt();
                            }
                            if (typeof y === 'string') {
                                y = y.charCodeAt();
                            }
                            if (sortType === 'asc') {
                                return x - y;
                            } else {
                                return y - x;
                            }
                        })
                        // .filter((v, i) => {
                        //     const start = limit * (page - 1);
                        //     const end = start + limit;
                        //     return i >= start && i < end;
                        // })
                    }
                        sortColumn={sortColumn}
                        sortType={sortType}
                        onSortColumn={handleSortColumn}
                    >
                        {columns.map(column => {
                            const { key, label, ...rest } = column;
                            return (
                                <rsuite.Table.Column {...rest} key={key} >
                                    <CustomHeaderCell>{label}</CustomHeaderCell>
                                    <rsuite.Table.Cell {...rest} dataKey={key}>
                                        {rowData => {
                                            let dynamicClass = "";

                                            if (rowData.DraftType == "Recipt") {
                                                dynamicClass = "text-success";
                                            } else {
                                                dynamicClass = "text-danger";
                                            }

                                            return <span className={`${dynamicClass}`}>{rowData[key]}</span>;
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                            );
                        })}
                    </rsuite.Table>

                    {/* <div style={{ paddingTop: 20 }}>
                        <rsuite.Pagination
                            prev
                            next
                            first
                            last
                            ellipsis
                            boundaryLinks
                            maxButtons={5}
                            size="xs"
                            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                            total={ItemList.length}
                            limitOptions={[5, 10, 30, 50, 100]}
                            limit={limit}
                            activePage={page}
                            onChangePage={setPage}
                            onChangeLimit={handleChangeLimit}
                        />
                    </div> */}
                </rsuite.Panel>



            </rsuite.Modal.Body>
            <rsuite.Modal.Footer>

                <rsuite.Button appearance="subtle" onClick={() => setOpen(false)}>
                    بستن
                </rsuite.Button>
            </rsuite.Modal.Footer>
        </rsuite.Modal>
    )
});

export default Modal_ProductCardex;